/*
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { VerifyShield } from '@zcode-ui/icons'
import { cn } from '@zcode-ui/shadz-ui'
import React from 'react'
import { PopoverTooltip } from '../PopoverTooltip/PopoverTooltip'
import verifiedIconSrc from './verifiedIcon.svg'

interface Props {
  'data-testid'?: string
  buttonClassName?: string
  disabled?: boolean
  isDirectDeal: boolean
  isNewDetailPage?: boolean
  isWhite?: boolean
  popoverContentClassName?: string
  popoverId?: string
  side?: 'top' | 'right' | 'bottom' | 'left'
  size: number
}

export const VerifiedIcon = ({
  'data-testid': dataTestId,
  buttonClassName,
  disabled = false,
  isDirectDeal,
  isNewDetailPage,
  isWhite,
  popoverContentClassName,
  popoverId,
  side,
  size,
}: Props) => {
  return isDirectDeal ? (
    <PopoverTooltip
      buttonClassName={cn('min-w-auto', buttonClassName)}
      dataTestId={dataTestId}
      disabled={disabled}
      label="Our team has verified this company"
      popoverContentClassName={popoverContentClassName}
      id={popoverId}
      side={side}
    >
      {isNewDetailPage ? (
        <VerifyShield
          data-testid="verified-svg"
          fillShield={isWhite ? '#FFFFFF' : undefined}
          fillCheck={isWhite ? '#022C3B' : undefined}
          size={size}
        />
      ) : (
        <img
          alt=""
          data-testid="verified-svg"
          height={size}
          loading="lazy"
          src={verifiedIconSrc}
          width={size}
        />
      )}
    </PopoverTooltip>
  ) : null
}
